import axios from '@/plugins/axios'


export default {
    state: {
        summariesList: [],
        downloadKey:""
    },
    mutations: {
        setSummariesList(state, summariesList) {
            if (summariesList && summariesList.length) {
                state.summariesList = summariesList.map(
                    (item, index) => {
                        return {
                            type: "summary",
                            id: `sum_${index}`,
                            name: item,
                        };
                    }
                );
            }

        },
        addToSummariesList(state, item) {
            state.summariesList.push({
                id: state.summariesList.length,
                type: "summary",
                name: item
            })
        },
        removeFromSummariesList(state, item) {
            let q = state.summariesList.findIndex((el) => {
                return el.name === item
            });
            state.summariesList.splice(q, 1)
        },
        renameDigest(state, obj) {
            let w = state.summariesList.findIndex((el) => {
                return el.name === obj.oldName
            })
            console.log(state.summariesList, w, state.summariesList[w]);
            state.summariesList[w].name = obj.newName
        }
    },
    actions: {
        GetSummariesNames({ commit }) {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/GetDigestNames", {})
                    .then((res) => {
                        commit('setSummariesList', res.data)
                        return res.data
                    })
                    .finally(() => {
                    });
            } catch (e) {
                throw e
            }
        },
        AddSummaries({ commit }, data) {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/AddDigest", data)
                    .then((res) => {
                        commit('addToSummariesList', res.data)
                        return res.data
                    })
                    .finally((res) => {
                    });
            } catch (e) {
                throw e
            }
        },
        renameDigest({ commit }, data) {
            try {
                axios
                    .post(
                        " http://core.memo.az/mainwindow/RenameDigest",
                        data
                    )
                    .then((res) => {
                        // commit('renameDigest', data)
                    })
                    .finally(() => { });
            } catch (e) {
                throw e
            }
        },
        DeleteSummary({ commit }, data) {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/DeleteDigest", data)
                    .then((res) => {
                        commit('removeFromSummariesList', data.digestName)
                        return res.data
                    })
                    .finally((res) => {
                    });
            } catch (e) {
                throw e
            }
        },
        saveDigets({ commit }, data) {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/SaveDigest", data)
                    .then((res) => {
                    })
                    .finally(() => {
                    });
            } catch (e) {

            }
        },
        downloadDigets({ commit }, obj) {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/GenerateDigest", obj)
                    .then((res) => {
                        return res.data
                    })
                    .finally((res) => {
                    })
            } catch (e) {

            }
        }
    },
    getters: {
        summariesList(state) {
            return state.summariesList
        },
    }
}